/* global NProgress */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.css'
// import 'vue-material/dist/theme/default-dark.css' // This line here
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import store from './stores/store'
// ... other imports ...
import axios from './backend/vue-axios'
import ability from './config/ability'
import { abilitiesPlugin } from '@casl/vue'
// Vue.use(VueMaterial)
import Vuetify from 'vuetify'
import colors from 'vuetify/es5/util/colors'

import {
  unpackRules
} from '@casl/ability/extra'

Vue.config.productionTip = true

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

Vue.use(Vuetify, {
  theme: {
    primary: colors.blueGrey.darken2,
    secondary: colors.blueGrey.lighten1,
    accent: colors.purple.base,
    error: colors.red.accent4,
    warning: colors.yellow.base,
    info: colors.blue.base,
    success: colors.green.base
  }
})

Vue.use(require('vue-moment'))

import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)

Vue.use(abilitiesPlugin, ability)
// TODO: the next line is added for debugging purposes and should be removed for production build
window.ability = ability

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

// // before a request is made start the nprogress
// axios.interceptors.request.use(config => {
//   NProgress.start()
//   return config
// })
//
// // before a response is returned stop nprogress
// axios.interceptors.response.use(response => {
//   NProgress.done()
//   return response
// })

Vue.mixin({
  methods: {
    processRules: function (ruleset) {
      var rules = [];

      ruleset.forEach(function(entry) {
        console.log(entry);
        rules.push(entry.casl_ability);
      });

      this.$store.dispatch('LOGIN')
      this.$ability.update(unpackRules(rules))
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  ability,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js